<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>Table of Contents</h1>
<p class="noindent"><a href="#/002halftitlepage">Half Title Page</a></p>
<p class="noindent"><a href="#/003praise">Praise</a></p>
<p class="noindent"><a href="#/004titlepage">Title Page</a></p>
<p class="noindent"><a href="#/005copyright">Copyright</a></p>
<p class="noindent"><a href="#/006dedication">Dedication</a></p>
<p class="noindent"><a href="#/008excerpt">Excerpt</a></p>
<p class="noindent" id="fairwarning"><a href="#/009fairwarning">Fair Warning</a></p>
<p class="noindent" id="p01"><a href="#/010part1">Part 1 Obsessive-Christianity Disorder</a></p>
<blockquote>
<p class="blockquote" id="ch01"><a href="#/011chapter1">1</a></p>
<p class="blockquote" id="ch02"><a href="#/012chapter2">2</a></p>
</blockquote>
<p class="noindent" id="p02"><a href="#/013part2">Part 2 Religion Is A Headache</a></p>
<blockquote>
<p class="blockquote" id="ch03"><a href="#/014chapter3">3</a></p>
<p class="blockquote" id="ch04"><span href="#/015chapter4" title="Link target outside of Sample">4</span></p>
<p class="blockquote" id="ch05"><span href="#/016chapter5" title="Link target outside of Sample">5</span></p>
<p class="blockquote" id="ch06"><span href="#/017chapter6" title="Link target outside of Sample">6</span></p>
<p class="blockquote" id="ch07"><span href="#/018chapter7" title="Link target outside of Sample">7</span></p>
<p class="blockquote" id="ch08"><span href="#/019chapter8" title="Link target outside of Sample">8</span></p>
<p class="blockquote" id="ch09"><span href="#/020chapter9" title="Link target outside of Sample">9</span></p>
<p class="blockquote" id="ch10"><span href="#/021chapter10" title="Link target outside of Sample">10</span></p>
</blockquote>
<p class="noindent" id="p03"><span href="#/022part3" title="Link target outside of Sample">Part 3 Crossing The Line</span></p>
<blockquote>
<p class="blockquote" id="ch11"><span href="#/023chapter11" title="Link target outside of Sample">11</span></p>
<p class="blockquote" id="ch12"><span href="#/024chapter12" title="Link target outside of Sample">12</span></p>
<p class="blockquote" id="ch13"><span href="#/025chapter13" title="Link target outside of Sample">13</span></p>
</blockquote>
<p class="noindent" id="p04"><span href="#/026part4" title="Link target outside of Sample">Part 4 Burning Matryoshkas</span></p>
<blockquote>
<p class="blockquote" id="ch14"><span href="#/027chapter14" title="Link target outside of Sample">14</span></p>
<p class="blockquote" id="ch15"><span href="#/028chapter15" title="Link target outside of Sample">15</span></p>
<p class="blockquote" id="ch16"><span href="#/029chapter16" title="Link target outside of Sample">16</span></p>
<p class="blockquote" id="ch17"><span href="#/030chapter17" title="Link target outside of Sample">17</span></p>
<p class="blockquote" id="ch18"><span href="#/031chapter18" title="Link target outside of Sample">18</span></p>
</blockquote>
<p class="noindent" id="p05"><span href="#/032part5" title="Link target outside of Sample">Part 5 Cheating On Jesus</span></p>
<blockquote>
<p class="blockquote" id="ch19"><span href="#/033chapter19" title="Link target outside of Sample">19</span></p>
<p class="blockquote" id="ch20"><span href="#/034chapter20" title="Link target outside of Sample">20</span></p>
<p class="blockquote" id="ch21"><span href="#/035chapter21" title="Link target outside of Sample">21</span></p>
<p class="blockquote" id="ch22"><span href="#/036chapter22" title="Link target outside of Sample">22</span></p>
<p class="blockquote" id="ch23"><span href="#/037chapter23" title="Link target outside of Sample">23</span></p>
<p class="blockquote" id="ch24"><span href="#/038chapter24" title="Link target outside of Sample">24</span></p>
<p class="blockquote" id="ch25"><span href="#/039chapter25" title="Link target outside of Sample">25</span></p>
</blockquote>
<p class="noindent" id="p06"><span href="#/040part6" title="Link target outside of Sample">Part 6 We Don’t Marry dead People</span></p>
<blockquote>
<p class="blockquote" id="ch26"><span href="#/041chapter26" title="Link target outside of Sample">26</span></p>
<p class="blockquote" id="ch27"><span href="#/042chapter27" title="Link target outside of Sample">27</span></p>
<p class="blockquote" id="ch28"><span href="#/043chapter28" title="Link target outside of Sample">28</span></p>
<p class="blockquote" id="ch29"><span href="#/044chapter29" title="Link target outside of Sample">29</span></p>
</blockquote>
<p class="noindent" id="p07"><span href="#/045part7" title="Link target outside of Sample">Part 7 Ego Assault</span></p>
<blockquote>
<p class="blockquote" id="ch30"><span href="#/046chapter30" title="Link target outside of Sample">30</span></p>
<p class="blockquote" id="ch31"><span href="#/047chapter31" title="Link target outside of Sample">31</span></p>
<p class="blockquote" id="ch32"><span href="#/048chapter32" title="Link target outside of Sample">32</span></p>
</blockquote>
<p class="noindent" id="nudereflections"><span href="#/049nudereflections" title="Link target outside of Sample">Nude Reflections</span></p>
<p class="noindent" id="sidebar"><span href="#/050sidebar" title="Link target outside of Sample">Sidebar</span></p>
<p class="noindent" id="acknowledgments"><span href="#/051acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="noindent" id="aboutthepublisher"><span href="#/052aboutthepublisher" title="Link target outside of Sample">About the Publisher</span></p>
<p class="noindent" id="consumer"><span href="#/053consumerengagement" title="Link target outside of Sample">Share Your Thoughts</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007toc.vue?d491af2e